module.exports = __webpack_public_path__ + "img/upload-xls-image.a19c8473.svg";